<script setup>
// RM-427: the questions on one screen of the application (or every screen,
// for the one-page personal-admin form), with the optional RM via text choice
// right under the mobile number. Shared by the sign-up form and the Admin
// preview so both show exactly the same thing.
import { computed } from 'vue'
import ApplicationQuestionField from '@core/components/application/ApplicationQuestionField.vue'
import SmsOptInChoice from '@core/components/application/SmsOptInChoice.vue'
import { isAsked } from '@/utils/applicationForm'

const props = defineProps({
  form: { type: Object, required: true },
  // a step key, or null for every question on one page
  step: { type: String, default: null },
  answers: { type: Object, required: true },
  errors: { type: Object, default: () => ({}) },
  smsOptIn: { type: Boolean, default: false },
  disabledKeys: { type: Array, default: () => [] },
  hints: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['update:smsOptIn', 'answer'])

const questions = computed(() => (props.form.questions || [])
  .filter(q => (props.step ? q.step === props.step : true))
  .filter(q => isAsked(q, props.answers)))

const offersSms = computed(() => !!(props.form.smsOptIn && props.form.smsOptIn.enabled))
</script>

<template>
  <div>
    <template
      v-for="q in questions"
      :key="q.key"
    >
      <ApplicationQuestionField
        :model-value="answers[q.key]"
        :question="q"
        :error-messages="errors[q.key] || []"
        :disabled="disabledKeys.includes(q.key)"
        :persistent-hint="hints[q.key] || ''"
        @update:model-value="v => emit('answer', q.key, v)"
      />
      <SmsOptInChoice
        v-if="q.key === 'phoneNumber' && offersSms"
        :model-value="smsOptIn"
        :copy="form.smsOptIn"
        @update:model-value="v => emit('update:smsOptIn', v)"
      />
    </template>
  </div>
</template>
